<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 智能门禁轮播图 -->
    <AccessControlBanner></AccessControlBanner>
    <!-- 智能门禁硬件描述 -->
    <Describe></Describe>
    <!-- 多种开门方式 生活更便捷 -->
    <OpenDoor></OpenDoor>
    <!-- 方案优势 -->
    <Advantage></Advantage>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import AccessControlBanner from '../../../../components/pc/Programme/AccessControlComponents/AccessControlBanner.vue'
import Describe from '../../../../components/pc/Programme/AccessControlComponents/Describe.vue'
import OpenDoor from '../../../../components/pc/Programme/AccessControlComponents/OpenDoor.vue'
import Advantage from '../../../../components/pc/Programme/AccessControlComponents/Advantage.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    AccessControlBanner,
    Describe,
    OpenDoor,
    Advantage,
  },
};
</script>

<style scoped>
</style>
